var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FormWrapper",
    { attrs: { title: "Payment methods" } },
    [
      _vm.isLoading
        ? _c("PaymentCardPlaceholder")
        : _c("div", [
            !_vm.paymentCardsExist
              ? _c(
                  "div",
                  { staticClass: "flex justify-between" },
                  [
                    _c("div", { staticClass: "mr-3" }, [
                      _c("p", [
                        _vm._v("Your Credit Card information is missing."),
                      ]),
                      _vm.needPaymentCard
                        ? _c("p", { staticClass: "text-red-600 text-low" }, [
                            _vm._v(
                              "Please add a Credit Card to continue having access to ProveraCare."
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("AddPaymentCardModal", {
                      attrs: {
                        currentUserId: _vm.currentUser.id,
                        actionButtonText: _vm.cardActionButtonText,
                      },
                      on: { cardAdded: _vm.refetch },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  _vm._l(_vm.paymentCards, function (card) {
                    return _c("PaymentCard", {
                      key: card.id,
                      staticClass: "card",
                      attrs: {
                        expMonth: card.exp_month,
                        expYear: card.exp_year,
                        last4: card.last4,
                        updatedAt: card.updated_at,
                        brand: card.brand,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "actions",
                            fn: function () {
                              return [
                                _c("EditPaymentCardModal", {
                                  attrs: {
                                    currentUserId: _vm.currentUser.id,
                                    cardId: card.id,
                                  },
                                  on: { cardEdited: _vm.refetch },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  }),
                  1
                ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }